<div class="LesitungEdit row" *ngIf="Entry && Entry != null">
  <div class="row">
    <div class="row">
      <div class="col edit">
        <AdminCard [Item]="Entry">
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="name" [(ngModel)]="Entry.name">
                <label for="name">Name</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="ik" [(ngModel)]="Entry.ik">
                <label for="ik">IK</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="mail" [(ngModel)]="Entry.mail">
                <label for="mail">E-Mail</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="telefone" [(ngModel)]="Entry.telefone">
                <label for="telefone">Telefone</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-check mb-3">
                <input name="antragAlsEmail" id="antragAlsEmail" class="form-check-input" type="checkbox"
                       [checked]="Entry.antragAlsEmail"
                       (change)="Entry.antragAlsEmail = !Entry.antragAlsEmail" />
                <label for="antragAlsEmail" class="form-check-label">Antrag als Email</label>
              </div>
            </div>
            <div class="col">
              <div class="form-check mb-3">
                <input name="antragAlsFax" id="antragAlsFax" class="form-check-input" type="checkbox"
                       [checked]="Entry.antragAlsFax"
                       (change)="Entry.antragAlsFax = !Entry.antragAlsFax" />
                <label for="antragAlsFax" class="form-check-label">Antrag Als Fax</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="Fax" [(ngModel)]="Entry.fax">
                <label for="Fax">Fax</label>
              </div>
            </div>

          </div>
          <div class="form-check mb-3">
            <input name="mipVerordnung" id="mipVerordnung" class="form-check-input" type="checkbox"
                   [checked]="Entry.mipVerordnung"
                   (change)="Entry.mipVerordnung = !Entry.mipVerordnung" />
            <label for="mipVerordnung" class="form-check-label">MIP als Verordnung</label>
          </div>
          <div class="form-check mb-3">
            <input name="mipSonstiges" id="mipSonstiges" class="form-check-input" type="checkbox"
                   [checked]="Entry.mipSonstiges"
                   (change)="Entry.mipSonstiges = !Entry.mipSonstiges" />
            <label for="mipSonstiges" class="form-check-label">MIP als Sonstiges</label>
          </div>
          <div class="form-check mb-3">
            <input name="mipNoMwst" id="mipNoMwst" class="form-check-input" type="checkbox"
                   [checked]="Entry.mipNoMwst"
                   (change)="Entry.mipNoMwst = !Entry.mipNoMwst" />
            <label for="mipNoMwst" class="form-check-label">MIP Ohne MWST</label>
          </div>
          <div class="form-check mb-3">
            <input name="mipMwstBrutto" id="mipMwstBrutto" class="form-check-input" type="checkbox"
                   [checked]="Entry.mipMwstBrutto"
                   (change)="Entry.mipMwstBrutto = !Entry.mipMwstBrutto" />
            <label for="mipMwstBrutto" class="form-check-label">MIP MWST Brutto</label>
          </div>
          <div class="form-check mb-3">
            <input name="disableMip" id="disableMip" class="form-check-input" type="checkbox"
                   [checked]="Entry.disableMip"
                   (change)="Entry.disableMip = !Entry.disableMip" />
            <label for="disableMip" class="form-check-label">
              Kein (Auto) Versand An Mip
            </label>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="mipLEGS" [(ngModel)]="Entry.mipLEGS">
                <label for="mipLEGS">MIP LEGS</label>
              </div>
            </div>
          </div>
          <div class="form-check mb-3">
            <input name="removeVersorgungUndProdBes" id="removeVersorgungUndProdBes" class="form-check-input" type="checkbox"
                   [checked]="Entry.removeVersorgungUndProdBes"
                   (change)="Entry.removeVersorgungUndProdBes = !Entry.removeVersorgungUndProdBes" />
            <label for="removeVersorgungUndProdBes" class="form-check-label">Mip Versorgungsart und Produktbesonderheit nicht Senden</label>
          </div>
          <div class="form-check mb-3">
            <input name="enableAutosetStatus1" id="enableAutosetStatus1" class="form-check-input" type="checkbox"
                   [checked]="Entry.enableAutosetStatus1"
                   (change)="Entry.enableAutosetStatus1 = !Entry.enableAutosetStatus1" />
            <label for="enableAutosetStatus1" class="form-check-label">Automatisches zuweisen von status 1</label>
          </div>
          <div class="form-check mb-3">
            <input name="setGenemigungDireckt" id="setGenemigungDireckt" class="form-check-input" type="checkbox"
                   [checked]="Entry.setGenemigungDireckt"
                   (change)="Entry.setGenemigungDireckt = !Entry.setGenemigungDireckt" />
            <label for="setGenemigungDireckt" class="form-check-label">AAuto Set Als Genemigt</label>
          </div>
          <div class="form-check mb-3">
            <input name="antragAlsEmail5154" id="antragAlsEmail5154" class="form-check-input" type="checkbox"
                   [checked]="Entry.antragAlsEmail5154"
                   (change)="Entry.antragAlsEmail5154 = !Entry.antragAlsEmail5154" />
            <label for="antragAlsEmail5154" class="form-check-label">Antrag als Email (PG: 51 / 54)</label>
          </div>
          <Date-Select [(Date)]="Entry.endDate" LabelText="End Date"></Date-Select>
          <Address [(address)]="Entry.adresse"></Address>
        </AdminCard>
      </div>
    </div>
  </div>
</div>
<div class="row Button">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="SaveData()">Speichern</div>
  </div>
</div>
<ng-template #successTpl> Speichern erfolgreich! </ng-template>
